import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Banner({ data }) {
    return (
        <div className="services_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>Cyberpsychologist Dr. Michael Nuccitelli Shares iPredators Vision</h1>
                        </div>
                        <div className="banner_content_txt listing_flex">
                            <p>In our latest Technology for a Change episode, Season 3, TekRevol’s Principal Product Strategist, Hady Shaikh, interviewed Dr. Michael Nuccitelli, a Cyberpsychology Doctor, Researcher, and the Founder of iPredators.org, a community support and therapy program against online victimization</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" // Fix: Replace "effect" prop with "effect="blur""
                            alt="Image"
                            className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;
